module.exports = __webpack_public_path__ + "static/img/tt-1.826afec.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/tt-1.jpg
 ** module id = 588
 ** module chunks = 2
 **/